// Shelf Temperature Constants
// see: app/models/shelf.rb, enum: temperature
export const SHELF_TEMPERATURES = [
  'ambient',
  'controlled',
  'refrigerated',
  'frozen',
  'air_conditioned'
];
